module.exports = __webpack_public_path__ + "img/ruban_1.fbbcae2f.png";